(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('historicoDemarcacao', HistoricoDemarcacao);

  function HistoricoDemarcacao() {
    return {
      restrict: 'E',
      controller: 'HistoricoDemarcacaoCtrl',
      controllerAs: 'demarcacao',
      templateUrl: 'views/propriedade/historico-demarcacao.html'
    };
  }
}());
